import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import {
  Alert,
  Avatar,
  Button,
  Card,
  Col,
  Form,
  Modal,
  Row,
  Select,
  Space,
  Tag,
  Typography,
  message,
} from "antd";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import MainCreateOrderAddress from "./AddressSection/MainCreateOrderAddress";
import MainCreateOrderProduct from "./ProductSection/MainCreateOrderProduct";
import {
  FactoryCreateOrderInput,
  FactoryCreateOrderItems,
  FindAgentResponse,
  GetAgentByIdResponse,
  GetBankAllListInput,
  GetBankAllListResponse,
  LoadTaxInvoiceListResponse,
  OrderAddressData,
  OrderProductsTemporaryItem,
  PaymentOrderItems,
  PriceTransportationInput,
  TaxAddressData,
  TaxInvoiceOrderItems,
} from "services/interface";
import { useGetBankAdminList, useGetBankAllList } from "hooks/useFactory";
import { AddressData } from "components/ManageAgent/CreateAgent/AddressComponents/interface/address.interface";
import CreateOrderFooter from "./CreateOrderFooter";
import {
  useCreateOrderAdmin,
  useLoadTaxInvoiceList,
  useMutatePriceTransportation,
  useTaxInvoiceDataList,
} from "hooks/useOrders";
import MainCreateOrderPayment from "./PaymentSection/MainCreateOrderPayment";
import { useAppDispatch, useAppSelector } from "store";
import MainOrderDatasource from "./DatasourceSection/MainOrderDatasource";
import { formatYearMonthDateWithTime } from "utils/dateFormat";
import { backendUrl } from "config";
import MainCreatePriceTransportation from "./PriceTransportationSection/MainCreatePriceTransportation";
import MainCreateTotalPricePayment from "./TotalPricePaymentSection/MainCreateTotalPricePayment";
import { setTabSelected } from "store/slices/orderSlice";
import MainCreateOrderDuedate from "./DuedateSection/MainCreateOrderDuedate";
import { Image } from "antd";
import noImage from "assets/images/no-image.png";
import { useFindAgentData } from "hooks/useAgents";
import Meta from "antd/es/card/Meta";
import dayjs from "dayjs";
import { CrownOutlined, UserOutlined } from "@ant-design/icons";
import MainCreateOrderTax from "./TaxSection/MainCreateOrderTax";
import { setLoading } from "store/slices/loadingSlice";
import { useGetParkingTransportAreaTypeMutation } from "hooks/useShipping";
const { Option } = Select;

interface CommentList {
  price_id: string;
  comment_text: string;
}

const CreateOrder = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [telephone, setTelephone] = useState<string>("");
  const [dataAddress, setDataAddress] = useState<AddressData[]>([]);
  const [dataAddressTax, setDataAddressTax] = useState<TaxAddressData[]>([]);
  const [requestTax, setRequestTax] = useState<boolean>(false);

  // const { data: dataAgentList, isLoading: telephoneIsLoadding, refetch: refetchAgentList } = useGetAgentByTelephone(telephone);
  const [userData, setUserData] = useState<GetAgentByIdResponse>();
  const [agentList, setAgentList] = useState<FindAgentResponse>();

  // const [agentData, setAgentData] = useState<FindAgenUserData>();
  // const { mutate: searchTelephone } = useGetAgentByTelephoneMutate();
  const { mutate: searchAgent } = useFindAgentData();
  const { mutate: createOrderAdmin } = useCreateOrderAdmin();
  const [dataTemporary, setDataTemporary] = useState<
    OrderProductsTemporaryItem[]
  >([]);
  const [radioSelect, setRadioSelect] = useState<string>("");
  const [paymentDate, setPaymentDate] = useState<Date | null>(null);
  const [dueDate, setDueDate] = useState<Date | null>(null);

  const [addressIdSelected, setAddressIdSelected] = useState<string>("");

  const [messageError, setMessageError] = useState<string>("");

  const [find, setFind] = useState<boolean>(false);
  const [empty, setEmpty] = useState<boolean>(false);
  const [transport, setTransport] = useState<string>("");
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [servicePrice, setServicePrice] = useState<number>(0);
  const [disCount, setDisCount] = useState<number>(0);

  const [editingKey, setEditingKey] = useState("");
  const [currentSelected, setCurrentSelected] = useState<string>("");

  const [formSubmit] = Form.useForm();

  const { mutate: calServicePrice } = useMutatePriceTransportation();

  const factoryId = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const { mutate: mutateParkingTransportAreaType } =
    useGetParkingTransportAreaTypeMutation();

  useEffect(() => {
    const addressShip = dataAddress.find(
      (address) => address.address_id === radioSelect
    );

    const payload: PriceTransportationInput = {
      transport_type: transport,
      total_price: totalPrice,
      province_id: addressShip?.province_id ?? 0,
      factory_id: factoryId || "",
      district_id: addressShip?.district_id ?? 0,
    };

    if (userData?.data.ref_type === "agent") {
      payload.agent_id = userData?.data.id;
    } else if (userData?.data.ref_type === "retail") {
      payload.retail_id = userData?.data.id;
    }

    calServicePrice(payload, {
      onSuccess: async (data) => {
        setServicePrice(data.data.service_price);
      },
      onError: (error) => {
        console.log(error);
      },
    });
  }, [userData?.data.id, totalPrice, transport, radioSelect]);

  // const factory_id = useAppSelector((state) => state.auth.profile?.user?.role?.ref_id);

  const [dataBank, setDataBank] = useState<GetBankAllListResponse>();
  const { mutate: bankAdminList } = useGetBankAdminList();

  useEffect(() => {
    if (userData && userData.data.id && userData.data.ref_type) {
      const bankInput: GetBankAllListInput = {
        ref_id: userData.data.id,
        ref_type: userData.data.ref_type,
        status: "active",
      };

      bankAdminList(bankInput, {
        onSuccess: (data) => {
          if (data.status === "success") {
            setDataBank(data);
          }
        },
        onError: (error) => {},
      });
    }
  }, [userData]);

  //useTaxInvoiceDataList
  // const [dataTax, setDataTax] = useState<LoadTaxInvoiceListResponse>()
  // const { mutate: loadDataTax } = useTaxInvoiceDataList();

  // useEffect(() => {
  //   if (userData && userData.data.id && factoryId) {
  //     const taxInput : LoadTaxInvoiceListInput = {
  //       factory_id: factoryId,
  //       customer_id: userData.data.id,
  //     };

  //     loadDataTax(taxInput, {
  //       onSuccess: (data) => {
  //         if (data.status === "success") {
  //           setDataTax(data);
  //         }
  //       },
  //       onError: (error) => {

  //       },
  //     });
  //   }
  // }, [factoryId, userData])

  const {
    data: dataTax,
    isPending: taxPending,
    refetch: refetchTax,
  } = useLoadTaxInvoiceList({
    factory_id: factoryId ?? "",
    customer_id: userData?.data.id ?? "",
  });

  useEffect(() => {
    if (userData && dataTax?.data) {
      const newTaxAddresses: TaxAddressData[] = dataTax.data.map(
        (tax: TaxAddressData) => {
          return {
            id: tax.id,
            name: tax.name,
            address_text: tax.address_text,
            telephone: tax.telephone,
            fax: tax.fax,
            email: tax.email,
            tax_no: tax.tax_no,
            factory_id: factoryId ?? "",
            ref_id: userData.data.id,
            ref_type: userData.data.ref_type,
            is_active: tax.is_active,
          };
        }
      );

      setDataAddressTax(newTaxAddresses);

      const activeAddress = newTaxAddresses.find((tax) => tax.is_active);
      if (activeAddress) {
        setAddressIdSelected(activeAddress.id);
      } else {
        setAddressIdSelected("");
      }
    }
  }, [userData, dataTax]);

  const childrenBank: React.ReactNode[] = [];
  dataBank &&
    dataBank?.data?.map((item) => {
      return childrenBank.push(
        <Option key={item.id} value={item.id}>
          <OptionContent>
            <ImageWrapper>
              <Image
                src={item.image ?? noImage}
                alt={item.bank_name}
                preview={false}
              />
            </ImageWrapper>
            <span>
              {item.bank_name} {item.account_no} {item.account_name}
            </span>
          </OptionContent>
        </Option>
      );
    });

  // useEffect(() => {
  //   setServicePrice(serviceData?.data.service_price ?? 0)
  // }, [serviceData]);

  useEffect(() => {
    const addressShip = dataAddress.find(
      (address) => address.address_id === radioSelect
    );

    if (!addressShip?.province_id) {
      return;
    }

    mutateParkingTransportAreaType(
      {
        factory_id: factoryId || "",
        province_id: addressShip?.province_id || 0,
        district_id: addressShip?.district_id || 0,
      },
      {
        onSuccess: (data) => {
          console.log("xxx--->", data);
          // ตรวจสอบว่า data มีค่าไหม
          if (data.data.length > 0) {
            // fitter ข้อมูลใน data.data ที่ config_list ไม่เป็นค่าว่าง ออก
            const newData = data.data.filter(
              (item) => item.config_list.length > 0
            );
            // ตรวจสอบว่า newData มีค่าไหม
            console.log("newData--->", newData);
            if (newData.length > 0) {
              // ตรวจสอบว่า newData[0].transport_type ตรงกับ shipAddress.transport_type หรือไม่
              const isMatch = newData.some(
                (item) => item.transport_type === addressShip?.transport_type
              );

              console.log("isMatch--->", isMatch);
              if (isMatch) {
                console.log("ตรงกัน");
                // onFinishAfterCheck(values);
                setMessageError("");
              } else {
                setMessageError(
                  "ที่อยู่ที่คุณเลือกไม่รองรับการจัดส่งของโรงงาน กรุณาเลือกที่อยู่ใหม่"
                );
                message.error(
                  "ที่อยู่ที่คุณเลือกไม่รองรับการจัดส่งของโรงงาน กรุณาเลือกที่อยู่ใหม่"
                );
              }
            } else {
              setMessageError(
                "ที่อยู่ที่คุณเลือกไม่รองรับการจัดส่งของโรงงาน กรุณาเลือกที่อยู่ใหม่"
              );
              message.error(
                "ที่อยู่ที่คุณเลือกไม่รองรับการจัดส่งของโรงงาน กรุณาเลือกที่อยู่ใหม่"
              );
            }
          }
        },
      }
    );
    setTransport(addressShip?.transport_type ?? "");
  }, [radioSelect]);

  const refetchData = () => {
    searchAgent(
      {
        ref_id: userData?.data.id || "",
        ref_type: userData?.data.ref_type || "",
      },
      {
        onSuccess: (data) => {
          setUserData({
            data: {
              ...data.data.data_user[0],
              contact_type: data.data.data_user[0].ref_type,
            },
          });
        },
        onError: () => {
          message.error("ไม่พบรายการลูกค้า");
          clearState();
        },
      }
    );
  };
  const handleSearchMobile = (tel: string) => {
    setTelephone(tel);
    searchAgent(
      {
        search: tel,
      },
      {
        onSuccess: (data) => {
          clearState();
          if (Number(data.data.total_record ?? 0) > 1) {
            setFind(true);
            setAgentList(data);
          } else if (Number(data.data.total_record ?? 0) === 1) {
            setUserData({
              data: {
                ...data.data.data_user[0],
                contact_type: data.data.data_user[0].ref_type,
              },
            });
            message.success("ค้นหาสำเร็จ");
          } else {
            setEmpty(true);
          }
          // setAgentData(data);
          //todolist: ถา้เจอมากกว่าหนึ่งให้ขึ้น modal
          // message.success("");
          //refetch();
          // navigate("/manage-agent");
        },
        onError: () => {
          message.error("ไม่พบรายการลูกค้า");
          clearState();
        },
      }
    );
  };

  const clearState = () => {
    setDataAddress([]);
    setDataTemporary([]);
    setRadioSelect("");
    setUserData(undefined);
    formSubmit.resetFields();

    const now = dayjs();
    const defaultDate = now.hour() < 10 ? now : now.add(1, "day");
    setDueDate(defaultDate.toDate());
  };

  const onFinishAfterCheck = (values: any) => {
    dispatch(setLoading(true));

    const refIdKey =
      userData?.data.ref_type === "agent" ? "agent_id" : "retail_id";

    const payment: PaymentOrderItems = {
      amount: values.payment_amount,
      bank_id: values.bank_id,
      image_slip: values?.payment_images
        ? `${backendUrl}images/${values.payment_images[0].id}`
        : "",
    };

    if (paymentDate) {
      payment.payment_date = formatYearMonthDateWithTime(paymentDate);
    }
    const addressShip = dataAddress.find(
      (address) => address.address_id === radioSelect
    );
    let shipAddressData: OrderAddressData | undefined;
    if (addressShip) {
      shipAddressData = {
        address_id: addressShip.address_id || "",
        address_line_1: addressShip.line_1 || "",
        address_line_2: addressShip.line_2 || "",
        ref_id: userData?.data.id || "",
        ref_type: userData?.data.ref_type || "",
        address_type: addressShip.address_type || "",
        address_name: addressShip.address_name || "",
        address_telephone: addressShip.address_telephone || "",
        transport_type: addressShip.transport_type || "",
        location_type: addressShip.location_type || "",
        province_id: addressShip.province_id || 0,
        address_detail: addressShip.address_detail || "",
        is_default: addressShip.is_default || false,
        province_name: addressShip.province_name || "",
        district_id: addressShip.district_id || 0,
        district_name: addressShip.district_name || "",
        sub_district_id: addressShip.sub_district_id || 0,
        sub_district_name: addressShip.sub_district_name || "",
        zip_code: addressShip.post_code || "0",
        remark: addressShip.remark,
        parking_id: addressShip.parking_id || "",
        // geolocation_th: "",
        // geolocation_en: "",
        // country_th: "",
        // country_en: "",
        // geolocation: "",
        // location_text: "",
        address_text: addressShip.address_text || "",
      };
    }
    console.log(dataTemporary);
    const productItems: FactoryCreateOrderItems[] = dataTemporary.map(
      (item) => ({
        product_id: item.product_id,
        price_id: item.price_id || "",
        item_qty: item.qty,
        factory_price: item.factory_price,
        wholesale_price: item.wholesale_price,
        retail_price: item.retail_price,
        vip_price: item.vip_price,
        sku_qty: item.product_quantity,
        factory_id: item.factory_id,
        comment_text: item.comment_text ?? null,
      })
    );

    const addressTax = dataAddressTax.find(
      (address) => address.id === addressIdSelected
    );
    let taxInvoiceItems: TaxInvoiceOrderItems | null = null;
    if (addressTax) {
      taxInvoiceItems = {
        tax_invoice_id: addressTax?.id,
        factory_id: factoryId || "",
        ref_id: userData?.data.id || "",
        ref_type: userData?.data.ref_type || "",
        tax_no: addressTax?.tax_no || "",
        name: addressTax?.name || "",
        address: addressTax?.address_text || "",
        telephone: addressTax?.telephone || "",
        // fax: addressTax?.fax || null,
        // email: addressTax?.email || null,
      };
    }

    let dataCreate: FactoryCreateOrderInput;
    const is_vip = userData?.data.is_vip ? userData?.data.is_vip : false;
    const privilege_type = is_vip ? userData?.data.privilege_type : "";
    if (values.bank_id) {
      dataCreate = {
        factory_id: factoryId || "",
        agent_id: userData?.data.id,
        ship_address: shipAddressData,
        payment_type: "manual_transfer",
        datasource: values.datasource,
        ref_type: userData?.data?.ref_type || "",
        transport_price: servicePrice,
        product_list: productItems,
        payment: [payment],
        due_date: dueDate,
        memo: values.memo,
        discount_amount: disCount,
        req_tax: requestTax,
        is_vip: is_vip,
        privilege_type: is_vip ? privilege_type : "",
        ...(taxInvoiceItems && requestTax
          ? { tax_invoice: taxInvoiceItems }
          : {}),
      };
    } else {
      dataCreate = {
        factory_id: factoryId || "",
        agent_id: userData?.data.id,
        ship_address: shipAddressData,
        payment_type: "manual_transfer",
        datasource: values.datasource,
        ref_type: userData?.data?.ref_type || "",
        transport_price: servicePrice,
        product_list: productItems,
        due_date: dueDate,
        memo: values.memo,
        discount_amount: disCount,
        req_tax: requestTax,
        is_vip: is_vip,
        privilege_type: is_vip ? privilege_type : "",
        ...(taxInvoiceItems && requestTax
          ? { tax_invoice: taxInvoiceItems }
          : {}),
      };
    }

    createOrderAdmin(dataCreate, {
      onSuccess: (res) => {
        if (res.status === "success") {
          message.success("สร้างคำสั่งซื้อสำเร็จ");
          dispatch(setTabSelected(0));
          navigate("/order");
          dispatch(setLoading(false));
        } else {
          dispatch(setLoading(false));
          message.error(`สร้างคำสั่งซื้อไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        dispatch(setLoading(false));
        message.error(`สร้างคำสั่งซื้อไม่สำเร็จ: ${error.message}`);
      },
    });
  };

  const onFinish = (values: any) => {
    const addressShip = dataAddress.find(
      (address) => address.address_id === radioSelect
    );

    mutateParkingTransportAreaType(
      {
        factory_id: factoryId || "",
        province_id: addressShip?.province_id || 0,
        district_id: addressShip?.district_id || 0,
      },
      {
        onSuccess: (data) => {
          // ตรวจสอบว่า data มีค่าไหม
          if (data.data.length > 0) {
            // fitter ข้อมูลใน data.data ที่ config_list ไม่เป็นค่าว่าง ออก
            const newData = data.data.filter(
              (item) => item.config_list.length > 0
            );
            // ตรวจสอบว่า newData มีค่าไหม
            console.log(newData);
            if (newData.length > 0) {
              // ตรวจสอบว่า newData[0].transport_type ตรงกับ shipAddress.transport_type หรือไม่
              const isMatch = newData.some(
                (item) => item.transport_type === addressShip?.transport_type
              );
              if (isMatch) {
                console.log("ตรงกัน");
                onFinishAfterCheck(values);
              } else {
                console.log("ไม่ตรงกัน");
                setMessageError(
                  "ที่อยู่ที่คุณเลือกไม่รองรับการจัดส่งของโรงงาน กรุณาเลือกที่อยู่ใหม่"
                );
                message.error(
                  "ที่อยู่ที่คุณเลือกไม่รองรับการจัดส่งของโรงงาน กรุณาเลือกที่อยู่ใหม่"
                );
              }
            } else {
              setMessageError(
                "ที่อยู่ที่คุณเลือกไม่รองรับการจัดส่งของโรงงาน กรุณาเลือกที่อยู่ใหม่"
              );
              message.error(
                "ที่อยู่ที่คุณเลือกไม่รองรับการจัดส่งของโรงงาน กรุณาเลือกที่อยู่ใหม่"
              );
            }
          }
        },
      }
    );
  };

  // Ref for datasource Select
  const datasourceRef = useRef<any>(null);
  const paymentSectionRef = useRef<HTMLDivElement>(null);

  // Handle form validation failure to scroll/focus Select
  const handleFormFinishFailed = (errorInfo: any) => {
    const hasDatasourceError = errorInfo.errorFields?.some(
      (field: any) => field.name && field.name[0] === "datasource"
    );
    const hasPaymentSectionError = errorInfo.errorFields?.some(
      (field: any) =>
        field.name &&
        (field.name[0] === "payment_amount" ||
          field.name[0] === "payment_date" ||
          field.name[0] === "bank_id")
    );

    if (hasDatasourceError && datasourceRef.current) {
      if (typeof datasourceRef.current.focus === "function") {
        datasourceRef.current.focus();
      }
      if (typeof datasourceRef.current.scrollIntoView === "function") {
        datasourceRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    } else if (
      !hasDatasourceError &&
      hasPaymentSectionError &&
      paymentSectionRef.current
    ) {
      paymentSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      // focus input ตัวแรกที่ error ใน section การชำระเงิน
      const firstErrorField = errorInfo.errorFields.find(
        (field: any) =>
          field.name &&
          (field.name[0] === "payment_amount" ||
            field.name[0] === "payment_date" ||
            field.name[0] === "bank_id")
      );
      if (firstErrorField && paymentSectionRef.current) {
        const errorName = firstErrorField.name[0];
        const input = paymentSectionRef.current.querySelector(
          errorName === "payment_amount"
            ? 'input[name="payment_amount"]'
            : errorName === "payment_date"
            ? 'input[placeholder="ระบุวันและเวลาที่โอน"]'
            : errorName === "bank_id"
            ? 'input[role="combobox"]'
            : ""
        );
        if (input) {
          (input as HTMLElement).focus();
        }
      }
    }
  };

  return (
    <>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/order");
                }}>
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5}>
                สร้างคำสั่งซื้อสินค้า
              </Typography.Title>
              <RightIconWrapper></RightIconWrapper>
            </HeaderTabs>
            {/* <Form form={formSubmit} onFinish={onFinish}> */}
            <MainCreateOrderAddress
              agentData={userData}
              // form={formSearch}
              handleSearchMobile={handleSearchMobile}
              telephone={telephone}
              setTelephone={setTelephone}
              refetchData={refetchData}
              setRadioSelect={setRadioSelect}
              radioSelect={radioSelect}
              dataAddress={dataAddress}
              setDataAddress={setDataAddress}
            />
            {messageError && (
              <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                <Alert message={messageError} type="error" />
              </div>
            )}
            <Divider />
            <MainCreateOrderTax
              refetchData={refetchTax}
              dataAddressTax={dataAddressTax}
              setDataAddressTax={setDataAddressTax}
              refId={userData?.data.id ?? ""}
              refType={userData?.data.ref_type ?? ""}
              requestTax={requestTax}
              setRequestTax={setRequestTax}
              addressIdSelected={addressIdSelected}
              setAddressIdSelected={setAddressIdSelected}
            />
            <Divider />
            <Form
              form={formSubmit}
              onFinish={onFinish}
              onFinishFailed={handleFormFinishFailed}>
              <WrapperAll>
                <MainOrderDatasource
                  form={formSubmit}
                  datasourceRef={datasourceRef}
                />
                <MainCreateOrderDuedate
                  dueDate={dueDate}
                  setDueDate={setDueDate}
                />
                <Divider />
                <MainCreateOrderProduct
                  refId={userData?.data.id || ""}
                  refType={userData?.data.ref_type || ""}
                  dataTemporary={dataTemporary}
                  setDataTemporary={setDataTemporary}
                  canDelete={true}
                  canCreate={true}
                  canRepeat={true}
                  showStatusColumn={false}
                  setTotalPrice={setTotalPrice}
                  editingKey={editingKey}
                  setEditingKey={setEditingKey}
                  currentSelected={currentSelected}
                  setCurrentSelected={setCurrentSelected}
                  userData={userData?.data}
                />
                <Divider />
                <MainCreatePriceTransportation servicePrice={servicePrice} />
                <MainCreateTotalPricePayment
                  servicePrice={servicePrice}
                  totalPrice={totalPrice}
                  disCount={disCount}
                  setDisCount={setDisCount}
                />
                <Divider />
                <div ref={paymentSectionRef}>
                  <MainCreateOrderPayment
                    childrenBank={childrenBank}
                    paymentDate={paymentDate}
                    setPaymentDate={setPaymentDate}
                    switchOn={false}
                  />
                </div>
                {/* </Form> */}
                <Divider />
              </WrapperAll>

              <CreateOrderFooter
                radioSelect={radioSelect}
                dataTemporary={dataTemporary}
              />
            </Form>
          </Card>
        </Col>
      </Row>
      <Modal
        title={`ผลการค้นหามีทั้งหมด ${agentList?.data.total_record} รายการ`}
        open={find}
        maskClosable={false}
        onCancel={() => {
          setFind(false);
        }}
        width={600}
        style={{ top: 80 }}
        bodyStyle={{ maxHeight: "400px", overflowY: "auto" }}
        footer={null}>
        <>
          {agentList &&
            agentList.data.data_user.map((items, index) => (
              <StyledCard
                key={items.id}
                style={{
                  width: "100%",
                  backgroundColor: "#efefef",
                  margin: "10px",
                  padding: "10px",
                }}>
                <div
                  onClick={() => {
                    setUserData({
                      data: {
                        ...items,
                        contact_type: "agent",
                      },
                    });
                    setFind(false);
                  }}>
                  <Meta
                    avatar={
                      <Avatar
                        shape="square"
                        size={76}
                        src={items.image_url || noImage}
                      />
                    }
                    description={
                      <Space direction="vertical" size={0}>
                        <Space direction="horizontal" size={0}>
                          <Typography.Text strong>{items.name}</Typography.Text>
                          <Typography.Text className="text-order-agent-name">
                            {items && items.alias ? `(${items.alias})` : ""}
                          </Typography.Text>
                        </Space>
                        <Space direction="horizontal" size={0}>
                          <Typography.Text>ประเภท:</Typography.Text>
                          <Typography.Text>
                            {/* {"  "} {items?.ref_type ?? ""}{" "} */}
                            ลูกค้า
                          </Typography.Text>
                        </Space>
                        <Space direction="horizontal" size={0}>
                          <Typography.Text>ที่อยู่:</Typography.Text>
                          <Typography.Text>
                            {" "}
                            {items?.address_contact[0]?.location_text ??
                              ""}{" "}
                          </Typography.Text>
                        </Space>
                        <Space direction="horizontal" size={0}>
                          <Typography.Text>เบอร์โทรศัพท์:</Typography.Text>
                          <Typography.Text>
                            {" "}
                            {items.telephone_number ?? ""}
                          </Typography.Text>
                        </Space>
                        <Space direction="horizontal" size={0}>
                          <Typography.Text>Email:</Typography.Text>
                          <Typography.Text>
                            {" "}
                            {items.email ?? ""}
                          </Typography.Text>
                        </Space>
                        <Space direction="horizontal" size={0}>
                          {/* <Typography.Text>{items.email}</Typography.Text> */}
                        </Space>
                      </Space>
                    }
                  />
                </div>
                <div className="ant-card-actions">
                  {/* <ButtonSmall type="primary" onClick={()=> {
                  navigate(`/manage-agent/update-agent/${items.id}`);
                }} target="_blank">ดูข้อมูล</ButtonSmall> */}
                </div>
                <div className="ant-card-vip">
                  {items.is_vip && (
                    <Tag color="red">
                      <CrownOutlined /> VIP
                    </Tag>
                  )}
                  {items.is_connected && (
                    <Tag color="blue" style={{ margin: 0 }}>
                      <UserOutlined /> ลูกค้า
                    </Tag>
                  )}
                </div>
              </StyledCard>
            ))}
        </>
      </Modal>
      <Modal
        title={`ผลการค้นหามีทั้งหมด 0 รายการ`}
        open={empty}
        maskClosable={false}
        onCancel={() => {
          setEmpty(false);
        }}
        style={{ top: 80 }}
        cancelText="ปิด"
        okText="สร้างลูกค้าใหม่"
        onOk={() => {
          navigate(`/manage-agent/create-retail?telephone=${telephone}`);
        }}>
        <>
          <Alert
            message={`ไม่พบรายการลูกค้า`}
            description={`หากคุณต้องการสร้างข้อมูลลูกค้าใหม่ โดยใช้คำค้นหา "${telephone}" กรุณากดปุ่ม"สร้างลูกค้าใหม่`}
            type="warning"
            showIcon
          />
        </>
      </Modal>
    </>
  );
};

export default CreateOrder;

const StyledCard = styled(Card)`
  .ant-card-actions {
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 5px;
  }
  .ant-card-vip {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    margin: 5px;
  }
  .ant-card-meta-title {
    margin: 0;
  }
  &:hover {
    border-color: #40a9ff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }

  &.selected {
    border-color: #1890ff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

const ButtonSmall = styled(Button)`
  font-size: 12px;
  padding: 3px;
  height: 20px;
  width: 60px;
  color: #fff !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Divider = styled.div`
  border-bottom: 0.5px solid #e8e8e8;
  margin: 10px 0px 10px 0px;
`;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

const OptionContent = styled.div`
  display: flex;
  align-items: center;
`;

const ImageWrapper = styled.div`
  margin-right: 8px;
  width: 20px;
  height: 20px;
  img {
    margin-top: -10px;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
